// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__3IqL8","select":"Header_select__aJS_Z","clinic":"Header_clinic__3Q3GK"};